import { createAction, props } from '@ngrx/store';
import { AnnouncementTableItem } from '../../../../system-apps/admin-announcement/+definitions';

/**
 * Actions für den Delete-Announcement-Dialog.
 */
export class DeleteAnnouncementDialogActions {
  private static readonly prefix = '[Dialog Delete Announcement]';

  /**
   * Öffnet den Dialog mit dem zu löschenden Item.
   */
  public static open = createAction(
    `${this.prefix} Open dialog`,
    props<{ item: AnnouncementTableItem }>(),
  );

  /**
   * Schließt den Dialog ohne Aktion.
   */
  public static close = createAction(
    `${this.prefix} Close dialog`,
  );

  /**
   * Bestätigt das Löschen des Items.
   */
  public static confirm = createAction(
    `${this.prefix} Confirm delete`,
  );
}
